import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "v-application" }
const _hoisted_2 = { class: "bg-grey-lighten-5" }
const _hoisted_3 = {
  class: "d-flex",
  "no-gutters": ""
}
const _hoisted_4 = { class: "d-flex justify-space-between" }
const _hoisted_5 = {
  class: "mb-6 stock-selection d-flex",
  "no-gutters": ""
}
const _hoisted_6 = { class: "m-4" }
const _hoisted_7 = { class: "m-4" }
const _hoisted_8 = { class: "d-flex justify-space-between mt-3" }
const _hoisted_9 = {
  "no-gutters": "",
  class: "d-flex justify-content-center"
}

import { ref, computed } from 'vue'
import api from '../../api/v2/api'
import Exam from '../../api/v2/models/exam'

interface ExamForm {
  exam: Exam
  questionCount: number
}

// Reactive state

export default /*@__PURE__*/_defineComponent({
  __name: 'ExamCreationFromStock',
  setup(__props) {

const stockName = ref('')
const exams = ref<Exam[]>([])
const forms = ref<ExamForm[]>([])

// Computed
const showingExams = computed(() => {
  return exams.value.filter((exam) => !getIsSelected(exam))
})

const totalQuestionCount = computed(() => {
  let count = 0
  forms.value.forEach((form) => {
    count += parseInt(form.questionCount.toString())
  })
  return count
})

// Methods
const onSearch = async () => {
  exams.value = await api.admin.exam.index(stockName.value, Exam.TYPE_STOCK_EXAM)
}

const select = (exam: Exam) => {
  if (!getIsSelected(exam)) {
    forms.value.push({
      exam,
      questionCount: 0
    })
  }
}

const remove = (exam: Exam) => {
  if (getIsSelected(exam)) {
    const index = forms.value.findIndex((form) => form.exam.id === exam.id)
    if (index >= 0) {
      forms.value.splice(index, 1)
    }
  }
}

const getIsSelected = (exam: Exam) => {
  return forms.value.findIndex((form) => form.exam.id === exam.id) >= 0
}

const onSubmit = () => {
  api.admin.exam
    .post(
      forms.value.map((form) => {
        return { examId: form.exam.id, questionCount: form.questionCount }
      })
    )
    .then((response) => {
      location.href = location.href.split('?')[0] + `/${response.data.exam.id}`
    })
    .catch((error) => {
      alert(error.messages)
    })
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_text_field, {
                solo: "",
                modelValue: stockName.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((stockName).value = $event))
              }, null, 8 /* PROPS */, ["modelValue"]),
              _createVNode(_component_v_btn, {
                class: "m-2",
                outlined: "",
                color: "teal",
                onClick: onSearch
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("検索", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_col)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_col, { class: "stock-list" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createTextVNode(" ストック一選択 ", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showingExams.value, (exam) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: exam.id,
                  class: "d-flex justify-space-between align-center"
                }, [
                  _createTextVNode(_toDisplayString(exam.name) + " ", 1 /* TEXT */),
                  _createVNode(_component_v_btn, {
                    class: "m-2",
                    outlined: "",
                    color: "teal",
                    dark: "",
                    onClick: ($event: any) => (select(exam))
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("選択", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_col, { class: "stock-list" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(" ストックから質問数設定: " + _toDisplayString(totalQuestionCount.value) + " ", 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forms.value, (form) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: form.exam.id,
                  class: "stock-exam p-3 mb-3"
                }, [
                  _createTextVNode(_toDisplayString(form.exam.name) + " ", 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_text_field, {
                      solo: "",
                      modelValue: form.questionCount,
                      "onUpdate:modelValue": ($event: any) => ((form.questionCount) = $event),
                      type: "number"
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_v_btn, {
                      class: "m-2",
                      outlined: "",
                      color: "teal",
                      dark: "",
                      onClick: ($event: any) => (remove(form.exam))
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("削除", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_v_btn, {
          color: "success",
          dark: "",
          onClick: onSubmit
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("テスト作成", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}
}

})